import { render, staticRenderFns } from "./category_carousel.vue?vue&type=template&id=2766f7d8&"
import script from "./category_carousel.vue?vue&type=script&lang=js&"
export * from "./category_carousel.vue?vue&type=script&lang=js&"
import style0 from "./category_carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "category_carousel.vue"
export default component.exports